module.exports = __webpack_public_path__ + "img/KF.b1bf0a15.png";